import React from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './views/Home';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Home></Home>
      </div>
    </LanguageProvider>
  );
}

export default App;
